var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/date-macro.j2"] = require( "macros/date-macro.j2" );
dependencies["loyalty-birthday-month.j2"] = require( "loyalty-birthday-month.j2" );
dependencies["loyalty-birthday-day.j2"] = require( "loyalty-birthday-day.j2" );
dependencies["loyalty-birthday-years.j2"] = require( "loyalty-birthday-years.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-birthday-fields.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "loyalty/templates/loyalty-birthday-fields.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_4 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_4);
if(t_1.hasOwnProperty("hasErrors")) {
var t_5 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_5);
if(t_1.hasOwnProperty("validatedField")) {
var t_6 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_6);
if(t_1.hasOwnProperty("validatedSelect")) {
var t_7 = t_1.validatedSelect;
} else {
cb(new Error("cannot import 'validatedSelect'")); return;
}
context.setVariable("validatedSelect", t_7);
output += "\n";
env.getTemplate("macros/date-macro.j2", false, "loyalty/templates/loyalty-birthday-fields.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("dayOptions")) {
var t_11 = t_8.dayOptions;
} else {
cb(new Error("cannot import 'dayOptions'")); return;
}
context.setVariable("dayOptions", t_11);
if(t_8.hasOwnProperty("monthOptions")) {
var t_12 = t_8.monthOptions;
} else {
cb(new Error("cannot import 'monthOptions'")); return;
}
context.setVariable("monthOptions", t_12);
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loyaltyConfig")),"showBirthdayCapture")) {
output += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"profile") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"profile")),"dateOfBirth") || !env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"profile")),"dateOfBirth")) > 0) {
output += "\n\n        ";
var t_13;
t_13 = (lineno = 7, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyaltyForm.birthdayYears"]));
frame.set("birthdayYears", t_13, true);
if(frame.topLevel) {
context.setVariable("birthdayYears", t_13);
}
if(frame.topLevel) {
context.addExport("birthdayYears", t_13);
}
output += "\n        ";
var t_14;
t_14 = (lineno = 8, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyaltyForm.birthdayFieldsOrder"]));
frame.set("birthdayFieldsOrder", t_14, true);
if(frame.topLevel) {
context.setVariable("birthdayFieldsOrder", t_14);
}
if(frame.topLevel) {
context.addExport("birthdayFieldsOrder", t_14);
}
output += "\n\n        <div class=\"o-row\">\n\n            <fieldset>\n\n                <legend class=\"g-loyalty-form__field-birthday-legend c-form__legend c-loyalty__birthday-legend \">\n\n                    ";
output += runtime.suppressValue((lineno = 16, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_birthday-label"])), env.opts.autoescape);
output += "\n\n                </legend>";
frame = frame.push();
var t_17 = runtime.contextOrFrameLookup(context, frame, "birthdayFieldsOrder");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("field", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
if(t_18 == "MM") {
env.getTemplate("loyalty-birthday-month.j2", false, "loyalty/templates/loyalty-birthday-fields.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
})});
}
else {
if(t_18 == "DD") {
env.getTemplate("loyalty-birthday-day.j2", false, "loyalty/templates/loyalty-birthday-fields.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
})});
}
else {
if(t_18 == "YYYY") {
env.getTemplate("loyalty-birthday-years.j2", false, "loyalty/templates/loyalty-birthday-fields.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
})});
}
;
}
;
}
;
}
}
frame = frame.pop();
output += "</fieldset>\n\n        </div>\n\n    ";
;
}
output += "\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-birthday-fields.j2"] , dependencies)